import { Component } from '@angular/core';

@Component({
  selector: 'app-nvabar',
  standalone: true,
  imports: [],
  templateUrl: './nvabar.html',
  styleUrl: './nvabar.scss',
})
export  class Nvabar {

}
